module.exports = __webpack_public_path__ + "img/testimonial.bd4b360c.png";